// Servicio clientes - Sprint 32.
import apiClient from '../../../api/apiClient';

const BASE = '/clientes';

export async function listClientes({ page = 1, per_page = 50, q = '', pais = '', activo = '' } = {}) {
  const params = new URLSearchParams();
  params.set('page', page); params.set('per_page', per_page);
  if (q) params.set('q', q);
  if (pais) params.set('pais', pais);
  if (activo !== '') params.set('activo', activo);
  const r = await apiClient.get(BASE + '/?' + params.toString());
  const d = (r && r.data) || {};
  return { items: d.items || [], total: d.total || 0 };
}

export async function searchClientes(q, limit = 10) {
  const params = new URLSearchParams({ q: q || '', limit: String(limit) });
  const r = await apiClient.get(BASE + '/search?' + params.toString());
  return (r && r.data && r.data.items) || [];
}

export async function getCliente(id) {
  const r = await apiClient.get(BASE + '/' + id);
  return (r && r.data) || null;
}

export async function createCliente(payload) {
  const r = await apiClient.post(BASE + '/', payload);
  return (r && r.data) || null;
}

export async function updateCliente(id, payload) {
  const r = await apiClient.put(BASE + '/' + id, payload);
  return (r && r.data) || null;
}

export async function deactivateCliente(id) {
  return apiClient.delete(BASE + '/' + id);
}

export async function activateCliente(id) {
  return apiClient.post(BASE + '/' + id + '/activar', {});
}
